<template>
  <div>
    <div class="jumbotron container">
    <div class="row">
      <h1 class="col"><img src="@/assets/showcaseBall.png" width="50px" height="50px" style="margin-right: 20px;"/><router-link id="router-link" :to="{name : 'Today'}"><img src="@/assets/zuniLogo.svg"  width="260px" height="145px"/> <span style="color: white;"></span> </router-link></h1>
      
    <!-- <div>
    <b-form-select v-model="selected"  style="background: #113b15; color: white; border-color: green; font-size: 13px;">
      <b-form-select-option disabled>Select Language</b-form-select-option>
      <b-form-select-option v-for="language in languages" :key="language.id" @click="changeLang(language.code)"> <span>{{language.name}}</span> </b-form-select-option>
    </b-form-select>
  </div> -->
  <div>
  <b-dropdown id="dropdown-1" text="Select Language" style="background: #113b15 !important; color: white !important; font-size: 10px; !important" variant="outline-success" class="m-md-2 myMenu">
    <b-dropdown-item v-for="language in languages" :key="language.id" @click="changeLang(language.code, language.id)" >{{language.name}}</b-dropdown-item>
  </b-dropdown>
</div>
      </div>
  </div>
    
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';


export default {
  name: 'Showcase',
  data(){
    return{
      // locales: process.env.VUE_APP_SUPPORTED_LOCALE.split(','),
      cookiesObject: '',
      selected: '',
      languages: [],
    }
  },
  async beforeMount(){
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    if (cookiesObject.token) {
       var myHeaders = new Headers();
    myHeaders.append("Cookie", "__cfduid=de50d5d8cce3ff6592c911352191001a61602584234");

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

fetch(this.httpReq +"/user/me?token=" + cookiesObject.token, requestOptions)
  .then(response => response.json())
  .then(result => this.$i18n.locale = result.user.language.code)
  .catch(error => console.log('error', error));
      
    }


    if (cookiesObject.token) {
    const res = await fetch(this.httpReq +'/general/appData?token=' + this.cookiesObject.token, {method: 'get'});
    const data = await res.json();
    const languages = data.portal.languages;
    this.languages = languages;

    
    } else {
    const res = await fetch(this.httpReq +'/general/appData?portalId=' + this.cookiesObject.portalId, {method: 'get'});
    const data = await res.json();
    const languages = data.portal.languages;
    this.languages = languages;
    }

    if (!this.cookiesObject.token) {
    this.$i18n.locale = this.cookiesObject.lang;
    }
    // if (this.cookiesObject.lang != '') {
    // this.$i18n.locale = this.cookiesObject.lang;
    // }
        
    this.$forceUpdate();
  },

  

  methods: {
    ...mapActions(['setLang']),
    changeLang(value, value1){
      this.setLang(value, value1);
      if (this.lang != undefined) {
      this.$i18n.locale = this.cookiesObject.lang;
       document.cookie = 'lang =' + value;
       document.cookie = 'langId =' + value1;

      if (this.cookiesObject.token) {
              var myHeaders = new Headers();
    myHeaders.append("Cookie", "__cfduid=de50d5d8cce3ff6592c911352191001a61602584234");

    var requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(this.httpReq +"/user/language?languageId="+ value1 +"&token=" + this.cookiesObject.token, requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log('error', error))
      .then( setTimeout(function some() {
              location.reload();
      }, 500));
      }  
      else{
        location.reload();
      }    
      }
    },
    // switchLocaleEng(value){
    //   document.cookie = 'lang =' + value
    //   this.$i18n.locale = value;
    // },
  },
  watch:{
  },

  computed:{
       ...mapGetters(['lang', 'httpReq']),
  },

  props: {
  }
}
</script>

<style scoped>

.jumbotron {
    background-image: url('../assets/showcase.jpg');
    background-size: cover;
    height: 200px;
    width: 100%;
    margin: 0 auto;
  }

  #router-link, #router-link:visited, #router-link:active, #router-link:focus{
    text-decoration: none;
    border: 0;
    outline: 0;
  }

</style>
